'use client'

import { useMemo } from 'react'

import {
  ArrowLeftRight,
  Bot,
  Calendar,
  Coins,
  DatabaseZap,
  FileText,
  Gift,
  Globe,
  ListOrdered,
  Megaphone,
  Menu,
  MessageCircleQuestion,
  ScanBarcode,
  User,
  Users,
} from 'lucide-react'
import { usePathname } from 'next/navigation'

import { SelectInput } from '~/components/component-library'
import { SidebarSection } from '~/components/sidebar'
import { useNavigation } from '~/hooks/useNavigation'

import type { LucideIcon } from 'lucide-react'

type AdminNavItem = {
  title: string
  href: string
  Icon: LucideIcon
}

const ADMIN_NAV_ITEMS: AdminNavItem[] = [
  {
    title: 'Transactions',
    href: '/admin/transactions/',
    Icon: ArrowLeftRight,
  },
  {
    title: 'Referrals',
    href: '/admin/referrals/',
    Icon: ScanBarcode,
  },
  {
    title: 'Users',
    href: '/admin/users/',
    Icon: User,
  },
  {
    title: 'Workspaces',
    href: '/admin/teams/',
    Icon: Users,
  },
  {
    title: 'Accounts',
    href: '/admin/smart-accounts/',
    Icon: Menu,
  },
  {
    title: 'Tokens',
    href: '/admin/tokens/',
    Icon: Coins,
  },
  {
    title: 'Feedback',
    href: '/admin/feedback/',
    Icon: MessageCircleQuestion,
  },
  {
    title: 'Invoices',
    href: '/admin/invoices/',
    Icon: FileText,
  },
  {
    title: 'Schedules',
    href: '/admin/schedules/',
    Icon: Calendar,
  },
  {
    title: 'Sponsorships',
    href: '/admin/sponsorship-policies/',
    Icon: Gift,
  },
  {
    title: 'Automations',
    href: '/admin/automations/',
    Icon: Bot,
  },
  {
    title: 'Feature cards',
    href: '/admin/feature-cards/',
    Icon: Megaphone,
  },
  {
    title: 'Indexing',
    href: '/admin/indexing/',
    Icon: DatabaseZap,
  },
  {
    title: 'Queues',
    href: '/admin/queues/',
    Icon: ListOrdered,
  },
  {
    title: 'Pages',
    href: '/admin/pages/',
    Icon: Globe,
  },
]

export const AdminSidebar = () => {
  return (
    <SidebarSection
      items={ADMIN_NAV_ITEMS.map(({ title, href, Icon }) => ({
        title,
        href,
        prefix: <Icon />,
      }))}
    />
  )
}

export const MobileAdminNavigation = () => {
  const pathname = usePathname()
  const navigate = useNavigation()

  const activeItem = useMemo(
    () =>
      ADMIN_NAV_ITEMS.find((item) =>
        pathname ? pathname.startsWith(item.href) : false,
      ),
    [pathname],
  )

  return (
    <div className="w-full bg-surface p-4 pb-0 md:hidden dark:border-gray-800">
      <SelectInput
        options={ADMIN_NAV_ITEMS.map(({ title, href, Icon }) => ({
          label: title,
          value: href,
          icon: <Icon className="h-4 w-4" />,
        }))}
        size="small"
        placeholder="Select a page"
        selectedOption={activeItem?.href}
        selectValue={navigate}
      />
    </div>
  )
}
